import { FunctionComponent, ChangeEventHandler, FocusEventHandler, ReactNode } from 'react';

import { Input } from 'dibs-elements/exports/Input';

type Props = {
    autoComplete?: string;
    autoFocus?: boolean;
    dataTn: string;
    error?: string;
    isBlurred?: boolean;
    disabled?: boolean;
    name: string;
    maxLength?: string;
    onChange: ChangeEventHandler;
    onBlur?: FocusEventHandler;
    pattern?: string;
    placeholder?: string;
    type?: string;
    value: string;
    wrapperClass?: string;
    leftDecorator?: ReactNode;
    rightDecorator?: ReactNode;
};

const Text: FunctionComponent<Props> = props => {
    const {
        autoComplete = 'on',
        autoFocus = false,
        dataTn = '',
        error,
        isBlurred = false,
        disabled = false,
        maxLength,
        name,
        onBlur,
        onChange,
        pattern,
        placeholder = '',
        type = 'text',
        value,
        wrapperClass = '',
        leftDecorator,
        rightDecorator,
    } = props;

    /**
     * TODO: update when adding validation
     */
    const showError = !disabled && isBlurred && !!error;
    const hasValidText = isBlurred && !!value && !showError;

    return (
        <div className={wrapperClass} data-field={name}>
            <Input
                onChange={onChange}
                onBlur={onBlur}
                type={type}
                dataTn={dataTn}
                name={name}
                value={value}
                pattern={pattern}
                max={maxLength}
                placeholder={placeholder}
                errorMessage={showError && error}
                autoComplete={autoComplete}
                autoFocus={autoFocus}
                disabled={disabled}
                hasValidText={hasValidText}
                hasAnimatedPlaceholder
                size="large"
                maskForPrivacy
                leftDecorator={leftDecorator}
                rightDecorator={rightDecorator}
            />
        </div>
    );
};

export default Text;
